var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("SetupCenter"),
      _vm._v(" "),
      _c("IncomeDetailModule"),
      _vm._v(" "),
      _c("OrderModuleSetup"),
      _vm._v(" "),
      _c("InvitationSharingModule"),
      _vm._v(" "),
      _c("LeaderboardPageManagement"),
      _vm._v(" "),
      _c("SearchPageSettings"),
      _vm._v(" "),
      _c("invitationCodeModule"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }